import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'sidenav-content-header',
    templateUrl: './sidenav-content-header.component.html',
    styleUrls: ['./sidenav-content-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SidenavContentHeaderComponent implements OnInit {

  @Input() title: string | undefined | null = ''
  @Output() close = new EventEmitter()

  constructor() { }

  ngOnInit(): void {
  }

  onCloseClick() {
    this.close.emit()
  }

}
